
import * as L from 'leaflet';



const blueIcon = new L.Icon({
	iconUrl: './markers/marker-icon-2x-blue.png',
	shadowUrl: './markers/marker-shadow.png',
	iconSize: [25, 41],
	iconAnchor: [12, 41],
	popupAnchor: [1, -34],
	shadowSize: [41, 41]
});


export { blueIcon }


const goldIcon = new L.Icon({
	iconUrl: './markers/marker-icon-2x-gold.png',
	shadowUrl: './markers/marker-shadow.png',
	iconSize: [25, 41],
	iconAnchor: [12, 41],
	popupAnchor: [1, -34],
	shadowSize: [41, 41]
});


export { goldIcon }


const redIcon = new L.Icon({
	iconUrl: './markers/marker-icon-2x-red.png',
	shadowUrl: './markers/marker-shadow.png',
	iconSize: [25, 41],
	iconAnchor: [12, 41],
	popupAnchor: [1, -34],
	shadowSize: [41, 41]
});


export { redIcon }


const greenIcon = new L.Icon({
	iconUrl: './markers/marker-icon-2x-green.png',
	shadowUrl: './markers/marker-shadow.png',
	iconSize: [25, 41],
	iconAnchor: [12, 41],
	popupAnchor: [1, -34],
	shadowSize: [41, 41]
});


export { greenIcon }


const orangeIcon = new L.Icon({
	iconUrl: './markers/marker-icon-2x-orange.png',
	shadowUrl: './markers/marker-shadow.png',
	iconSize: [25, 41],
	iconAnchor: [12, 41],
	popupAnchor: [1, -34],
	shadowSize: [41, 41]
});

export {orangeIcon}

const yellowIcon = new L.Icon({
	iconUrl: './markers/marker-icon-2x-yellow.png',
	shadowUrl: './markers/marker-shadow.png',
	iconSize: [25, 41],
	iconAnchor: [12, 41],
	popupAnchor: [1, -34],
	shadowSize: [41, 41]
});


export { yellowIcon }


const violetIcon = new L.Icon({
	iconUrl: './markers/marker-icon-2x-violet.png',
	shadowUrl: './markers/marker-shadow.png',
	iconSize: [25, 41],
	iconAnchor: [12, 41],
	popupAnchor: [1, -34],
	shadowSize: [41, 41]
});


export { violetIcon }


var greyIcon = new L.Icon({
	iconUrl: './markers/marker-icon-2x-grey.png',
	shadowUrl: './markers/marker-shadow.png',
	iconSize: [25, 41],
	iconAnchor: [12, 41],
	popupAnchor: [1, -34],
	shadowSize: [41, 41]
});


export { greyIcon }


const blackIcon = new L.Icon({
	iconUrl: './markers/marker-icon-2x-black.png',
	shadowUrl: './markers/marker-shadow.png',
	iconSize: [25, 41],
	iconAnchor: [12, 41],
	popupAnchor: [1, -34],
	shadowSize: [41, 41]
});


export { blackIcon }

